module.exports = __webpack_public_path__ + "static/img/attestation2.4c72954.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/attestation2.png
// module id = 15+J
// module chunks = 2